import React from 'react'
import {useParams} from 'react-router-dom'
import useEffect from 'admin/hooks/useEffect'
import useGroup from 'admin/hooks/useGroup'
import useStateObject from 'admin/hooks/useStateObject'
import useDocument from 'admin/hooks/useDocument'
import InputField from 'admin/components/shared/InputField'
import Modal from 'admin/components/shared/Modal'
import Header from '../shared/Header'
import useModal from '../../hooks/useModal'
import ColorPickerField from '../shared/ColorPickerField'

export default () => {
  const {organisationID} = useParams()
  const {type, popModal} = useModal()
  const {errors, group, create} = useGroup(organisationID, type)
  const [form, setForm, resetForm] = useStateObject(group)

  useDocument({title: 'New group'})

  useEffect(() => setForm(group), [group])

  const handleCreate = e => {
    create(form, () => handleClose(e))
  }

  const handleClose = e => {
    e.preventDefault()
    resetForm(group)
    popModal('new-group', ['type'])
  }

  return (
    <Modal onClose={handleClose} flashId='new-group' minWidth='50%'>
      <Header title='New group'>
        <button className='button is-primary' onClick={handleCreate}>
          Create
        </button>
      </Header>
      <section className='section'>
        <div className='container'>
          <form>
            <div className='field is-grouped'>
              <div className='control is-expanded'>
                <InputField
                  type='text'
                  name='name'
                  autoComplete='off'
                  value={form.name || ''}
                  errors={errors.name}
                  onChange={setForm}
                />
              </div>
              <div className='control'>
                <label htmlFor='colour' className='label is-small'>
                  Colour
                </label>
                <ColorPickerField name='colour' value={form.colour || ''} onChange={setForm} />
              </div>
            </div>
          </form>
        </div>
      </section>
    </Modal>
  )
}
